import PropTypes from 'prop-types';

const API_PATH = '/api/v1/customers';

const ACHILLES_CUSTOMIZATION = {
  customerDisplayName: 'Online Pajak',
  image: '/OP.png'
};

const ACHILLES_EFAKTUR_DOWNLOAD_PATH = '/efaktur/achilles';

const CUSTOMIZATION_PROP_TYPES = {
  portalCustomization: PropTypes.shape({
    customerDisplayName: PropTypes.string.isRequired,
    customerId: PropTypes.number,
    image: PropTypes.string.isRequired
  }).isRequired
};

const GENERIC_PROP_TYPES = {
  pageDecorator: PropTypes.shape({
    image: PropTypes.string.isRequired
  }).isRequired
};

function siteBaseUrl() {
  return new URL(window.location.href).origin;
}

async function findPortalCustomization(customerPrefix) {
  const origin = siteBaseUrl();
  const url = new URL(`${API_PATH}/${customerPrefix}`, origin);
  return fetch(url);
}

export {
  ACHILLES_CUSTOMIZATION,
  ACHILLES_EFAKTUR_DOWNLOAD_PATH,
  CUSTOMIZATION_PROP_TYPES,
  GENERIC_PROP_TYPES,
  findPortalCustomization
};
